export default class Captcha {
  static startup() {
    const { 'Google Recaptcha': allowed } = window.theme.consent || { 'Google Recaptcha': false };

    if (!allowed) return;

    window.recaptcha_callback = () => {
      const captchas = document.querySelectorAll('.g-recaptcha');

      captchas.forEach((captcha) => {
        const sitekey = captcha.getAttribute('data-sitekey');
        window.grecaptcha.render(captcha.id, { sitekey });
      });
    };

    const script = document.createElement('script');
    script.src =
      'https://www.google.com/recaptcha/api.js?onload=recaptcha_callback&render=explicit';
    script.async = true;
    document.body.appendChild(script);
  }
}
